import { VaroCategories } from 'shared/analytics/types/categories';
import { createBaseEventsMap } from 'shared/analytics/utils/createBaseEventsMap';

const EVENT_KEYS = {
  PLAID_LINK_INITIATED: 'Plaid Link Initiated',
  PLAID_LINK_OPENED: 'Plaid Link Opened',
  PLAID_LINK_STEP_COMPLETED: 'Plaid Link Step Completed',
  PLAID_LINK_EXITED: 'Plaid Link Exited',
  PLAID_EXTERNAL_ACCOUNT_LINKED: 'Plaid External Account Linked',
  PLAID_LINK_ERROR: 'Plaid Link Error Encountered',
  PLAID_MAX_LINK_ATTEMPTS_REACHED: 'Plaid Max Retries Reached',
};

export type VaroExternalAccountEvents =
  (typeof EVENT_KEYS)[keyof typeof EVENT_KEYS];

const events = createBaseEventsMap<VaroExternalAccountEvents>(
  EVENT_KEYS,
  VaroCategories.EXTERNAL_ACCOUNT,
);

export const {
  PLAID_LINK_INITIATED,
  PLAID_LINK_OPENED,
  PLAID_LINK_STEP_COMPLETED,
  PLAID_LINK_EXITED,
  PLAID_EXTERNAL_ACCOUNT_LINKED,
  PLAID_LINK_ERROR,
  PLAID_MAX_LINK_ATTEMPTS_REACHED,
} = events;

export const PLAID_INTEGRATION_VERSION_V2 = '2';
